import { cn } from "src/lib/utils/cn";

export const authFieldLabelClasses = "block text-sm font-medium text-dark-60 dark:text-gray-300";
export const authFieldErrorClasses = "text-sm text-red-600 dark:text-red-400";
export const authFormAlertClasses =
  "rounded-lg border border-red/20 bg-red/5 px-4 py-3 text-sm text-red-700 shadow-sm dark:border-red/30 dark:bg-red/10 dark:text-red-300";
export const authPrimaryButtonClasses =
  "h-11 gap-2 rounded-lg text-base focus:ring-offset-white dark:focus:ring-offset-gray-950";
export const authSecondaryButtonClasses =
  "h-11 rounded-lg focus:ring-offset-purple-5 dark:focus:ring-offset-gray-950";

const authInputBaseClasses =
  "h-11 w-full rounded-lg border bg-white px-3 text-sm text-dark-100 placeholder:text-dark-60 shadow-sm transition-all duration-200 hover:border-dark-20 focus:border-purple-100 focus:outline-none focus:ring-2 focus:ring-purple-100/30 dark:border-gray-700 dark:bg-gray-950/80 dark:text-gray-100 dark:placeholder:text-gray-500 dark:hover:border-gray-600";
const authInputDefaultClasses = "border-gray-300";
const authInputErrorClasses = "border-red/60 bg-red/5 focus:border-red focus:ring-red/20";
const authTextLinkBaseClasses =
  "block text-center text-sm font-medium text-purple-100 underline-offset-4 transition-colors hover:text-dark-purple-100 hover:underline focus:outline-none focus:ring-2 focus:ring-purple-100/50 focus:ring-offset-2 dark:text-purple-300 dark:hover:text-purple-200 dark:focus:ring-offset-gray-950";

export const authTextLinkClasses = cn(authTextLinkBaseClasses, "focus:ring-offset-white");
export const authSuccessTextLinkClasses = cn(authTextLinkBaseClasses, "focus:ring-offset-purple-5");

export function getAuthInputClasses({
  hasError = false,
  className,
}: {
  hasError?: boolean;
  className?: string;
}) {
  return cn(
    authInputBaseClasses,
    className,
    hasError ? authInputErrorClasses : authInputDefaultClasses,
  );
}
